import {
    useSubCategoriesInstagram,
    useUserIndustriesInstagram,
} from 'utils/hooks/useUserIndustries';
import { DATA_SOURCES } from '@/config/constants';
import { INSTAGRAM_METADATA_BY_KEY } from 'utils/metrics';
import { createSourceBreadCrumbs } from './createSourceBreadCrumbs';

const instagramMetrics = [
    INSTAGRAM_METADATA_BY_KEY.non_cum_avg_weekly_likes,
    INSTAGRAM_METADATA_BY_KEY.non_cum_MoM_rolling,
].map(({ key, tableHeadColumnLabel: label, format: formatter }) => ({
    key,
    label,
    formatter,
}));

const {
    BreadCrumbs: InstagramBreadCrumbs,
    IndustriesOnlyBreadCrumbs: InstagramIndustriesOnlyBreadCrumbs,
} = createSourceBreadCrumbs({
    dataSource: DATA_SOURCES.INSTAGRAM,
    useSubcategories: useSubCategoriesInstagram,
    useIndustries: useUserIndustriesInstagram,
    metrics: instagramMetrics,
});

export { InstagramIndustriesOnlyBreadCrumbs };

export default InstagramBreadCrumbs;
